/**
 * component-sakura-rain.js
 * Custom Element <sakura-rain count="18" container="db-hero">
 * Lot 2 Batch A — EDJ Shopify theme
 */
(function () {
  class SakuraRain extends HTMLElement {
    connectedCallback() {
      // Respect prefers-reduced-motion
      const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (mq.matches) return;

      const count = parseInt(this.getAttribute('count') || '18', 10);
      const container = this.getAttribute('container') || 'sakura';

      // Inject keyframes once per container id
      const styleId = `sakura-kf-${container}`;
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          @keyframes sakura-fall-c-${container} {
            0%   { transform: translate3d(0, -10%, 0) rotate(0deg); }
            100% { transform: translate3d(var(--sway), 120vh, 0) rotate(540deg); }
          }
        `;
        document.head.appendChild(style);
      }

      // Generate petals
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < count; i++) {
        const left    = Math.random() * 100;
        const delay   = Math.random() * 18;
        const dur     = 18 + Math.random() * 14;
        const size    = 7 + Math.random() * 9;
        const sway    = 30 + Math.random() * 50;
        const opacity = 0.35 + Math.random() * 0.4;

        const span = document.createElement('span');
        span.style.cssText = [
          'position:absolute',
          'top:-20px',
          `left:${left}%`,
          `width:${size}px`,
          `height:${(size * 0.85).toFixed(1)}px`,
          'background:radial-gradient(ellipse at 30% 30%, #f5cbd4, #e8a8b3 60%, #c8848e)',
          'border-radius:60% 40% 60% 40% / 50% 60% 40% 50%',
          'box-shadow:0 0 6px rgba(232,168,179,0.4)',
          `opacity:${opacity.toFixed(2)}`,
          `--sway:${sway.toFixed(0)}px`,
          `animation:sakura-fall-c-${container} ${dur.toFixed(1)}s linear ${delay.toFixed(2)}s infinite`,
          'pointer-events:none',
          'will-change:transform',
        ].join(';');

        fragment.appendChild(span);
      }

      this.appendChild(fragment);

      // Listen for motion preference changes at runtime
      mq.addEventListener('change', (e) => {
        if (e.matches) {
          // Remove all animations
          this.querySelectorAll('span').forEach(s => {
            s.style.animation = 'none';
          });
        }
      });
    }
  }

  if (!customElements.get('sakura-rain')) {
    customElements.define('sakura-rain', SakuraRain);
  }
})();
